import { Image, Button, Upload, UploadFile, UploadProps } from "antd";
import { useCallback, useEffect, useState } from "react";
import ConfirmDelete from "../ConfirmDelete";
import { PopUp } from "../PopUp";
import { ErrorMessage } from "../Toasts/ErrorMessage";
import { DeleteIcon, UploadIcon } from "../CustomIcons";

type uploadProps = {
  loading: boolean;
  uploadedImages?: string[];
  onImageDelete?: (fileName: string) => void;
  saveUpload: () => void;
  setChecklistFile: React.Dispatch<React.SetStateAction<File[] | null>>;
  imageUploaded?: { id: string; url: string; type: string }[];
};

type PreviewImage = {
  uid: string;
  file: string;
  imagePreviewUrl: string;
  imageId?: string;
};

const UploadFullMultiple = (props: uploadProps) => {
  const {
    loading,
    onImageDelete,
    setChecklistFile,
    imageUploaded = [],
  } = props;

  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [previewImages, setPreviewImages] = useState<PreviewImage[]>([]);
  const [confirmDelete, setConfirmDelete] = useState<{
    visible: boolean;
    target?: string;
    imageId?: string;
  }>({ visible: false, target: undefined, imageId: undefined });

  const onChange: UploadProps["onChange"] = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const handleFileChange = useCallback(
    (file: File) => {
      const isIMG = file.type === "image/png" || file.type === "image/jpeg";
      if (!isIMG) {
        ErrorMessage(`${file.name} is not an image file`);
        return Upload.LIST_IGNORE;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImages((prev) => [
          ...prev,
          {
            uid: `${file.name}-${Date.now()}`,
            file: file.name,
            imagePreviewUrl: reader.result as string,
          },
        ]);
        setChecklistFile((prev) => (prev ? [...prev, file] : [file]));
      };
      reader.readAsDataURL(file);

      return false; // prevent auto-upload
    },
    [setChecklistFile]
  );

  const deleteFunction = (fileName: string, imageId?: string) => {
    if (onImageDelete && imageId) onImageDelete(imageId);
    setPreviewImages((prev) => prev.filter((img) => img.file !== fileName));
    setChecklistFile((prev) =>
      prev ? prev.filter((file) => file.name !== fileName) : null
    );
    setConfirmDelete({ visible: false, target: undefined });
  };

  useEffect(() => {
    if (imageUploaded.length > 0) {
      setPreviewImages(() => [
        ...imageUploaded.map(
          (url: { id: string; url: string; type: string }) => ({
            uid: url?.id,
            imageId: url?.id,
            file: url?.url || "",
            imagePreviewUrl: url?.url || "",
          })
        ),
      ]);
    }
  }, [imageUploaded]);

  console.log(previewImages);

  return (
    <>
      <div className="service_picture_wrap">
        <div
          className="multiUploadWrapper"
          // style={{ width: previewImages?.length === 0 ? "100%" : "50%" }}
        >
          <Upload
            fileList={fileList}
            multiple
            showUploadList={false}
            onChange={onChange}
            beforeUpload={handleFileChange}
            customRequest={() => null}
            accept="image/png, image/jpeg"
          >
            <p className="ant-upload-drag-icon">
              <UploadIcon />
            </p>
            <p className="ant-upload-text">
              Drag & drop or <span>browse</span> to choose a file
            </p>
            <p className="ant-upload-hint">
              The file size should be less than 5 MB.
            </p>
          </Upload>
        </div>

        <div className="preview_grid">
          {previewImages.map((img) => (
            <div key={img.uid} className="preview_item">
              <Image src={img.imagePreviewUrl} alt={img.file} preview={false} />
              <Button
                danger
                size="small"
                onClick={() =>
                  setConfirmDelete({
                    visible: true,
                    target: img.file,
                    imageId: img?.imageId,
                  })
                }
              >
                <DeleteIcon />
              </Button>
            </div>
          ))}
        </div>
      </div>

      <PopUp
        visibility={confirmDelete.visible}
        class="upload_photo_modal"
        content={
          <ConfirmDelete
            title=""
            onClose={() => setConfirmDelete({ visible: false })}
            heading="Delete photo"
            paragraph="Delete this photo?"
            btnText="Delete photo"
            btnApi={() =>
              confirmDelete.target &&
              deleteFunction(confirmDelete.target, confirmDelete?.imageId)
            }
            loading={loading}
          />
        }
        width={480}
        onCancel={() => setConfirmDelete({ visible: false })}
      />
    </>
  );
};

export default UploadFullMultiple;
